import services from '../views/Orders/services';
import { getCurrentUTCTimestamp } from './dateResolvers';

interface OrderMetaInfo {
  ackTime?: string;
  [key: string]: any;
}
export default async function updateAckTime(
  orderId: string,
  setOrderMetaInfoWithOrderId: (orderId: string, metaInfo: OrderMetaInfo) => void
) {
  try {
    const ackTime = getCurrentUTCTimestamp();
    
    await services.updateOrderMetaInfo(orderId, {
      ackTime
    });
    
    setOrderMetaInfoWithOrderId(orderId, {
      ackTime
    });
    return ackTime;
  } catch (error) {
    console.error("Failed to update ACK time:", error);
    throw error;
  }
} 